import UnboaredApp from "./UnboaredApp";

const App = () => {

    return ( < UnboaredApp / > );
}

export default App;